import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "59",
  height: "59",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "M40.274 7.023h12.92c1.142 0 2.237.394 3.045 1.095.808.7 1.261 1.65 1.261 2.64v37.356c0 .99-.453 1.94-1.261 2.641-.808.7-1.903 1.094-3.045 1.094h-12.92M29.177 57.476l-25.84-3.088a2.26 2.26 0 0 1-1.322-.636A1.73 1.73 0 0 1 1.5 52.52V8.865c.008-.421.18-.827.488-1.153a2.23 2.23 0 0 1 1.206-.64l25.84-5.529c.313-.06.638-.057.95.006.313.064.605.188.856.362.25.174.453.395.593.646.139.25.212.525.213.804v52.297c0 .267-.067.53-.197.773s-.318.458-.553.631-.51.3-.807.371a2.5 2.5 0 0 1-.912.043"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "3",
      d: "M19.81 30.439c.594 0 1.076-.418 1.076-.934s-.482-.934-1.077-.934M19.776 30.439c-.594 0-1.076-.418-1.076-.934s.482-.934 1.076-.934"
    }, null, -1)
  ])))
}
export default { render: render }